var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordHide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 10,
    fill: "none",
    viewBox: "0 0 25 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2D3142",
    fillRule: "evenodd",
    d: "M22.429.923c-.203-.195-.487-.252-.738-.175-.185.028-.36.125-.482.285-1.403 1.836-3.95 3.993-7.075 4.613-3.058.606-6.83-.227-10.835-4.66C3.287.972 3.274.96 3.26.946 2.974.647 2.5.636 2.2.923L.393 2.65c-.3.286-.31.76-.024 1.06.286.3.76.31 1.06.024l1.26-1.203C3.765 3.653 4.84 4.55 5.903 5.25l-1.04 1.692c-.217.352-.107.814.246 1.031.353.217.815.107 1.032-.246L7.198 6.01c1.441.745 2.853 1.143 4.21 1.268v1.527c0 .415.335.75.75.75.414 0 .75-.335.75-.75V7.307c.516-.027 1.023-.092 1.518-.19 1.29-.256 2.482-.734 3.552-1.335l1.195 1.944c.218.353.68.463 1.032.246.353-.217.463-.679.246-1.031l-1.207-1.964c1.07-.762 1.978-1.625 2.688-2.454L23.2 3.734c.3.286.774.276 1.06-.024.287-.3.276-.774-.024-1.06L22.43.923z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordHide);
export default __webpack_public_path__ + "static/media/password-hide.6d4010b5f1073ff17dc58c7188e2ba11.svg";
export { ForwardRef as ReactComponent };